import { analyticsTypes } from '../types';

import { LABELS } from './labels';

export const columns: analyticsTypes.RequestsTableColumn[] = [
  { key: 'pageName', label: LABELS.PAGE_NAME },
  { key: 'date', label: LABELS.DATE },

  { key: 'newSpreadsBot', label: LABELS.NEW_SPREADS_BOT },
  { key: 'newSpreadsManual', label: LABELS.NEW_SPREADS_MANUAL },
  { key: 'newKeywordsBot', label: LABELS.NEW_KEYWORDS_BOT },
  { key: 'newKeywordsManual', label: LABELS.NEW_KEYWORDS_MANUAL },
  { key: 'newSpreadsTotal', label: LABELS.NEW_SPREADS_TOTAL },
  { key: 'newKeywordsTotal', label: LABELS.NEW_KEYWORDS_TOTAL },
  { key: 'newTotal', label: LABELS.NEW_TOTAL },

  { key: 'repeatingSpreadsManual', label: LABELS.REPEATING_SPREADS_MANUAL },
  { key: 'repeatingKeywordsBot', label: LABELS.REPEATING_KEYWORDS_BOT },
  { key: 'repeatingKeywordsManual', label: LABELS.REPEATING_KEYWORDS_MANUAL },
  { key: 'repeatingSpreadsTotal', label: LABELS.REPEATING_SPREADS_TOTAL },
  { key: 'repeatingKeywordsTotal', label: LABELS.REPEATING_KEYWORDS_TOTAL },
  { key: 'repeatingTotal', label: LABELS.REPEATING_TOTAL },

  { key: 'newDialogs', label: LABELS.NEW },
  { key: 'accepted', label: LABELS.RECEIVED },
  { key: 'sentToManager', label: LABELS.SENT_TO_MANAGERS },
];

export const TRIGGERS_ANALYTICS_COLUMNS: analyticsTypes.TriggersTableColumn[] = [
  { key: 'platform', label: LABELS.PLATFORM },
  {
    key: 'expert',
    label: LABELS.EXPERT_PAGE,
  },
  {
    key: 'totalIncoming',
    label: LABELS.TOTAL_INCOMING,
  },
  {
    key: 'withKeyword',
    label: LABELS.WITH_KEYWORD,
  },
  {
    key: 'withDate',
    label: LABELS.WITH_DATE,
  },
  {
    key: 'repeated',
    label: LABELS.REPEATED,
  },
  {
    key: 'aiKeyword',
    label: LABELS.AI_KEYWORD,
  },
  {
    key: 'aiDate',
    label: LABELS.AI_DATE,
  },
  {
    key: 'underage',
    label: LABELS.UNDERAGE,
  },
  {
    key: 'withoutKeywordAndDate',
    label: LABELS.WITHOUT_KEYWORD_AND_DATE,
  },
];

export const INSTAGRAM_TABLE_HEADERS = [
  { key: 'postLink', label: LABELS.POST },
  { key: 'publishDate', label: LABELS.PUBLISHED },
  { key: 'pageLink', label: LABELS.PAGE },
  { key: 'geo', label: LABELS.GEO },
  { key: 'topic', label: LABELS.TOPIC },
  { key: 'placementCost', label: LABELS.COST },
  { key: 'reactions', label: LABELS.REACTIONS },
  { key: 'uniqueUsersWithReactionsCount', label: LABELS.UNIQUE_REACTIONS },
  { key: 'newDialogs', label: LABELS.NEW_DIALOGS },
  { key: 'metrics', label: LABELS.METRICS },
];
